// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The name of the event
 * @export
 */
export const EventName = {
    EVENT_PROJECT_VIEWED: 'project_viewed',
    EVENT_PROJECT_COMPLETED: 'project_completed',
    EVENT_PROJECT_NEXT_PROJECT_CLICKED: 'project_next_project_clicked',
    EVENT_PROJECT_DISCOVER_MORE_CLICKED: 'project_discover_more_clicked',
    EVENT_PROJECT_SHARE_OPTION_CLICKED: 'project_share_option_clicked',
    EVENT_PRO_CLICKED: 'pro_clicked',
    EVENT_CHECKOUT_CANCELLED: 'checkout_cancelled',
    EVENT_CHECKOUT_SUCCESS: 'checkout_success',
    EVENT_NAVIGATION_SCROLLED_TO: 'navigation_scroll_to',
    EVENT_NAVIGATION_SIDEBAR_OPENED: 'navigation_sidebar_open',
    EVENT_INVITE_LINK_COPIED: 'invite-link-copied',
    EVENT_IMAGE_ZOOMED: 'image_zoomed',
    EVENT_CODE_SNIPPET_COPIED: 'code_snippet_copied',
    EVENT_DOCUMENTATION_VIEWED: 'documentation_viewed',
    EVENT_SOCIAL_SHARE_CLICKED: 'social_share_clicked',
    EVENT_PROJECT_TRACK_CLICKED: 'project_track_clicked',
    EVENT_VALIDATION_BOX_ACTION_CLICKED: 'validation_box_action_clicked',
    EVENT_TIME_SWITCHER_TIME_CHANGED: 'time_switcher_time_changed',
    EVENT_TIME_SWITCHER_TOPIC_CHANGED: 'time_switcher_topic_changed',
    EVENT_EDITOR_HIGHLIGHT_ADDED: 'editor_highlight_added',
    EVENT_EDITOR_HIGHLIGHT_REMOVED: 'editor_highlight_removed',
    EVENT_EDITOR_SIMPLIFIED: 'editor_simplified',
    EVENT_EDITOR_EXPLAINED: 'editor_explained',
    EVENT_EDITOR_EXAMPLES: 'editor_examples',
    EVENT_EDITOR_ASKED: 'editor_asked',
    EVENT_EDITOR_BLANK_NOTE_CREATED: 'editor_blank_note_created',
    EVENT_DIRECTORY_TAB_CHANGED: 'directory_tab_changed',
    EVENT_DIRECTORY_ADD_TO_MY_PROJECTS_CLICKED: 'directory_add_to_my_projects_clicked',
    EVENT_MY_PROJECTS_FILTER_CHANGED: 'my_projects_filter_changed',
    EVENT_MY_PROJECTS_VIEW_CHANGED: 'my_projects_view_changed',
    EVENT_DIRECTORY_SERIES_VIEWED: 'directory_series_viewed',
    EVENT_MY_PROJECTS_SORT_CHANGED: 'my_projects_sort_changed',
    EVENT_MY_PROJECTS_ADD_PROJECT_CLICKED: 'my_projects_add_project_clicked',
    EVENT_MOBILE_BANNER_REMIND_ME_CLICKED: 'mobile_banner_remind_me_clicked',
    EVENT_PORTFOLIO_COMING_SOON_RATING_CLICKED: 'portfolio_coming_soon_rating_clicked',
    EVENT_PROJECT_UNLOCKED: 'project_unlocked',
    EVENT_PROJECT_RESET_MODAL_OPENED: 'project_reset_modal_opened',
    EVENT_PROJECT_RESET_TRIGGERED: 'project_reset_triggered',
    EVENT_PRO_SECTION_UNLOCKED: 'pro_section_unlocked',
    EVENT_PORTFOLIO_LINK_COPIED: 'portfolio_link_copied',
    EVENT_PORTFOLIO_DOCUMENT_ADDED: 'portfolio_document_added',
    EVENT_PORTFOLIO_DOCUMENT_DELETED: 'portfolio_document_deleted',
    EVENT_PORTFOLIO_DETAILS_UPDATED: 'portfolio_details_updated',
    EVENT_PORTFOLIO_DOCUMENT_EDITED: 'portfolio_document_edited',
    EVENT_PORTFOLIO_DOCUMENT_VIEWED: 'portfolio_document_viewed',
    EVENT_SEARCH_PREFILLED: 'search_prefilled',
    EVENT_VALIDATION_EDITED: 'validation_edited',
    EVENT_CONTENT_TABS_CHANGED: 'content_tabs_changed',
    EVENT_USER_SYNC_INFO_UPDATED: 'user_sync_info_updated',
    EVENT_QUIZ_STARTED: 'quiz_started',
    EVENT_QUIZ_COMPLETED: 'quiz_completed',
    EVENT_QUIZ_QUESTION_ANSWERED: 'quiz_question_answered',
    EVENT_BOOKMARK_TOGGLED: 'bookmark_toggled',
    EVENT_FEEDBACK_CLICKED: 'feedback_clicked',
    EVENT_NAV_ITEM_CLICKED: 'nav_item_clicked',
    EVENT_PAYWALL_TRIGGERED: 'paywall_triggered',
    EVENT_PAYWALL_BUTTON_CLICKED: 'paywall_button_clicked',
    EVENT_PAYWALL_BILLING_PERIOD_TOGGLED: 'paywall_billing_period_toggled',
    EVENT_DOCUMENTATION_THEME_CLICKED: 'documentation_theme_clicked',
    EVENT_SECTION_TOGGLED: 'section_toggled',
    EVENT_INTERNAL_CONTENT_LINK_CLICKED: 'internal_content_link_clicked',
    EVENT_PROFILE_UPDATED: 'profile_updated',
    EVENT_PIN_TOGGLED: 'pin_toggled'
} as const;
export type EventName = typeof EventName[keyof typeof EventName];


export function instanceOfEventName(value: any): boolean {
    for (const key in EventName) {
        if (Object.prototype.hasOwnProperty.call(EventName, key)) {
            if (EventName[key as keyof typeof EventName] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventNameFromJSON(json: any): EventName {
    return EventNameFromJSONTyped(json, false);
}

export function EventNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventName {
    return json as EventName;
}

export function EventNameToJSON(value?: EventName | null): any {
    return value as any;
}

export function EventNameToJSONTyped(value: any, ignoreDiscriminator: boolean): EventName {
    return value as EventName;
}

